import React from "react";
import { Modal } from "react-bootstrap";
import { FiX } from "react-icons/fi";

function Exco1({ show, onClose, onOpen }) {
  return (
    <div>
      <div>
        <Modal
          size="lg"
          show={show}
          onHide={onClose}
          // backdrop="static"
          aria-labelledby="example-modal-sizes-title-lg"
          keyboard={false}
          animation={true}
          centered
        >
          <Modal.Body>
            <div className="Solera__Cont">
              <FiX className="Solera__Close" onClick={onClose} />
            </div>

            <div className="Exoc-Name">Akintoye Akinosi</div>
            <div className="Exco-Tittle">Social Secretary</div>
            <br />

            <div className="Excos-Bio">
              Akin Akinosi has a BSc in Estate Management ((UNILAG), an MA in
              Property Valuation and Law and an MBA in Information Technology
              and Management from City University, London. He is a Member of the
              Institute of Residential Property Management.  <br /> <br />
              In addition, he is a Fellow of the following organisations: Royal
              Institution of Chartered Surveyors, National Association of Estate
              Agents and Association of Residential Letting Agents. <br />{" "}
              <br />
              Akin is a Registered Valuer and an Assessor / Examiner for the
              Royal Institution of Chartered Surveyors and Valuers. Akin is
              currently Director at Template Estates Limited and Sparkle Estates
              and Facilities Management Limited. <br /> <br />
              He has headed the Residential Teams of a number of top City Real
              Estate Companies in the UK including Aston Rose (Chartered
              Surveyors) and Fifield Glyn (Chartered Surveyors). He was also
              responsible for managing Westminster Council’s investment property
              portfolio and directly and responsible for overseeing the work of
              two commercial real estate companies namely, Nelson Bakewell and
              Dunlop Heywood.  <br /> <br />
              At Hackney Council, He raised £17.5million by disposing of assets
              which were surplus to requirements. <br /> <br />
              Akin Enjoys Tennis, Swimming, travelling and is an Arsenal
              Supporter.
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
}

export default Exco1;
